import { render } from "./SecondTierAgent.vue?vue&type=template&id=6cbc26c6&scoped=true"
import script from "./SecondTierAgent.vue?vue&type=script&lang=js"
export * from "./SecondTierAgent.vue?vue&type=script&lang=js"

import "./SecondTierAgent.vue?vue&type=style&index=0&id=6cbc26c6&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cbc26c6"]])

export default __exports__